module.exports = __webpack_public_path__ + "static/media/image_36.1ab51fd1.png";